import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './Carriers.frontend.types'

@Injectable({ providedIn: 'root' })
export class Carriers_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public Carriers: Carriers_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
